import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { PublicLocationsRepository } from '../../repositories/public-location.repository';
import { PublicLocationSequenceUpdateRequest } from '../../domain/models/public-location-job-sequence-update';

@Injectable({ providedIn: 'root' })
export class UpdatePublicLocationSequence
  implements UseCase<PublicLocationSequenceUpdateRequest[], boolean>
{
  constructor(
    private readonly publicLocationRepository: PublicLocationsRepository
  ) {}

  execute(request: PublicLocationSequenceUpdateRequest[]): Observable<boolean> {
    return this.publicLocationRepository.updatePublicLocationSequence(request);
  }
}
